export enum ENVIRONMENTS {
    DEV = "development",
    EMULATOR = "emulator",
    PROD = "production",
    FIREBASE = "firebase"
}

export const ENV = process.env.VUE_APP_ENV;
export const FIREBASE_CONFIG = process.env.VUE_APP_FIREBASE_CONFIG;
export const DEFAULT_IMG = "6b310bf7ce9d4f59885445e984a151cb";